import { render } from "./DeportesForm.vue?vue&type=template&id=a57d68da&scoped=true"
import script from "./DeportesForm.vue?vue&type=script&lang=js"
export * from "./DeportesForm.vue?vue&type=script&lang=js"

import "./DeportesForm.vue?vue&type=style&index=0&id=a57d68da&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a57d68da"]])

export default __exports__